import AvailabilitySearchConfig from "./smartSearchFields/Availability";
import BetweenDatesSearchConfig from "./smartSearchFields/BetweenDates";
import ExpectedSalarySearchConfig from "./smartSearchFields/ExpectedSalary";
import JobRoleSearchConfig from "./smartSearchFields/JobRole";
import LanguageSearchConfig from "./smartSearchFields/Language";
import LanguageLevelSearchConfig from "./smartSearchFields/LanguageLevel";
import ManagerSearchConfig from "./smartSearchFields/Manager";
import MobilitySearchConfig from "./smartSearchFields/Mobility";
import NameOrEmailSearchConfig from "./smartSearchFields/NameOrEmail";
import RatingSearchConfig from "./smartSearchFields/Rating";
import TechnologiesSearchConfig from "./smartSearchFields/Technologies";
import TypeOfWorkSearchConfig from "./smartSearchFields/TypeOfWork";
import YearOfExperienceSearchConfig from "./smartSearchFields/YearOfExperience";
import ZonesSearchConfig from "./smartSearchFields/Zones";
import MobileNumberSearchConfig from "./smartSearchFields/MobileNumber";
import GitHubSearchConfig from "./smartSearchFields/GitHub";
import LinkedInSearchConfig from "./smartSearchFields/Linkedin";
import MaritalStatusSearchConfig from "./smartSearchFields/MaritalStatus";
import NumberDependantsSearchConfig from "./smartSearchFields/NumberOfDependants";
import CurrentLocationSearchConfig from "./smartSearchFields/CurrentLocation";
import BirthDateSearchConfig from "./smartSearchFields/BirthDate";
import NationalitySearchConfig from "./smartSearchFields/Nationality";
import OtherSkillsConfig from "./smartSearchFields/OtherSkills";
import PersonalSkillsAndCompetencesSearchConfig from "./smartSearchFields/PersonalSkillsandCompetences";
import SeniorityLevelSearchConfig from "./smartSearchFields/SeniorityLevel";
import MainActivitiesSearchConfig from "./smartSearchFields/MainActivities";
import CommentsSearchConfig from "./smartSearchFields/Comments";
import PersonalCharacteristicsSearchConfig from "./smartSearchFields/PersonalCharacteristics";
import PersonalProfileSearchConfig from "./smartSearchFields/PersonalProfile";

export default async function getSmartSearchParammeter() {
  let parms = {};

  //load tecnologies from service testing

  parms["technologies"] = await TechnologiesSearchConfig("technologies");
  parms["zones"] = await ZonesSearchConfig("zones");
  parms["nameOrEmail"] = await NameOrEmailSearchConfig("nameOrEmail");
  parms["language"] = await LanguageSearchConfig("language");
  parms["languageLevel"] = await LanguageLevelSearchConfig("languageLevel");
  parms["availability"] = await AvailabilitySearchConfig("availability");
  parms["expectedSalary"] = await ExpectedSalarySearchConfig("expectedSalary");
  parms["mobility"] = await MobilitySearchConfig("mobility");
  parms["typeOfWork"] = await TypeOfWorkSearchConfig("typeOfWork");
  parms["betweenDates"] = await BetweenDatesSearchConfig("betweenDates");
  parms["jobRole"] = await JobRoleSearchConfig("jobRole");
  parms["managers"] = await ManagerSearchConfig("managers");
  parms["rating"] = await RatingSearchConfig("rating");
  parms["yearsOfExperience"] = await YearOfExperienceSearchConfig("yearsOfExperience");
  parms["mobileNumber"] = await MobileNumberSearchConfig("mobileNumber");
  parms["gitHub"] = await GitHubSearchConfig("gitHub");
  parms["linkedIn"] = await LinkedInSearchConfig("linkedIn");
  parms["maritalStatus"] = await MaritalStatusSearchConfig("maritalStatus");
  parms["numberOfDependantId"] = await NumberDependantsSearchConfig("numberOfDependantId");
  parms["countryId"] = await CurrentLocationSearchConfig("countryId");
  parms["cityId"] = await CurrentLocationSearchConfig("cityId");
  parms["birthdate"] = await BirthDateSearchConfig("birthdate");
  parms["nationalityId"] = await NationalitySearchConfig("nationalityId");
  parms["otherSkills"] = await OtherSkillsConfig("otherSkills");
  parms["personalSkillsAndCompetencesSearchConfig"] = await PersonalSkillsAndCompetencesSearchConfig("personalSkillsAndCompetencesSearchConfig");
  parms["seniorityLevel"] = await SeniorityLevelSearchConfig("seniorityLevel");
  parms["mainActivities"] = await MainActivitiesSearchConfig("mainActivities");
  parms["comments"] = await CommentsSearchConfig("comments");
  parms["personalCharacteristics"] = await PersonalCharacteristicsSearchConfig("personalCharacteristics");
  parms["personalProfile"] = await PersonalProfileSearchConfig("personalProfile");


  return parms;
}

export const order = {first: 1, second: 2, third: 3, fourth: 4 }